import store from 'store';

const dispatcher = (action, value) => {
  store.dispatch({ type: action, value });
};

export { dispatcher };
